import _isEmpty from 'lodash/isEmpty';
export default function (state = {
    isFetching: true
}, action) {
    let isFetching = true;
    switch (action.type) {
        
        
        case "VENDOR_GET_INVOICE_MEMBER_NAME":
            // console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, vendorInvoiceNames: action.payload, isFetching }
            case "VENDOR_GET_TERMINATED_VP_NAMES":
            // console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, vendorTerminatedVPNames: action.payload, isFetching }
        case "VENDOR_GET_OVERVIEW_VENDOR_PARTNER_VOLUME":
            // console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, vendorOverviewVendorPartnerVolume: action.payload, isFetching }
            case "VENDOR_GET_OVERVIEW_REBATE_NAMES_FILTERED":
            // console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, vendorOverviewRebateTypeNamesFiltered: action.payload, isFetching }
            case "VENDOR_GET_OVERVIEW_SOURCE_NAMES_FILTERED":
            // console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, vendorOverviewSourceNamesFiltered: action.payload, isFetching }
        case "VENDOR_GET_OVERVIEW_REBATE_NAMES":
            // console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, vendorOverviewRebateTypeNames: action.payload, isFetching }
            case "VENDOR_GET_OVERVIEW_SOURCE_NAMES":
            // nsertFeedbackUnapprovedSupplierFeedback
            isFetching = false;
            return { ...state, vendorOverviewSourceNames: action.payload, isFetching }
            case "VENDOR_GET_OVERVIEW_BH_NAMES":
           // console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, vendorOverviewBHNames: action.payload, isFetching }
        case "VENDOR_GET_CATEGORY_OVERVIEW_DATA":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, vendorCategoryOverviewData: action.payload, isFetching }
        case "VENDOR_GET_RANK_BY_CATEGORY_DATA":
            console.log('reducer called  ranj', action.payload);
            isFetching = false;
            return { ...state, vendorRankByCategoryData: action.payload, isFetching }
        case "VENDOR_GET_INVOICE_DATA":
           // console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, vendorInvoiceData: action.payload, isFetching }
        case "VENDOR_GET_SALES_CARD_DATA":
            console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, getVendorSalesRebatCardData: action.payload, isFetching }
        case "VENDOR_GET_OPPORTUNITY_BY_CATEGORY":
           // console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, vendorOpportunityByCategory: action.payload, isFetching }
        case "VENDOR_GET_TVOPPORTUNITY_BY_CATEGORY":
              //  console.log('reducer called ', action.payload);
                isFetching = false;
                return { ...state, vendortvOpportunityByCategory: action.payload, isFetching }
        case "VENDOR_GET_TOP_10_CATEGORIES":
           // console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, vendorTop10Categories: action.payload, isFetching }
        case "VENDOR_GET_TOP_10_MEMBERS_DATA":
           // console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, vendorTop10Members: action.payload, isFetching }
        case "MEMBER_VENDOR_NAMES":
           // console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, getMemberVendorNames: action.payload, isFetching }
        case "VENDOR_GET_OPPORTUNITY_BY_MEMBER":
               // console.log('reducer called ', action.payload);
                isFetching = false;
                return { ...state, vendorOpportunityByMember: action.payload, isFetching }
        case "VENDOR_GET_OVERALL_SALES_DATA_FOR_DASHBOARD_TAB":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, vendorOverallSales: action.payload, isFetching }
        case "VENDOR_GET_DASHBOARD_REBATE_CARDS":
          //  console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, rebateCards: action.payload, isFetching }
        case "VENDOR_DASHBOARD_GET_REBATES_OVERVIEW":
           // console.log('reducer called vendorRebatesOverview ', action.payload);
            isFetching = false;
            return { ...state, vendorRebatesOverview: action.payload, isFetching }
        case "VENDOR_GET_INDIVIDUAL_GROWTH_REBATE":
           // console.log('reducer called  ', action.payload);
            isFetching = false;
            return { ...state, vendorIndividualGrowth: action.payload, isFetching }
        case "VENDOR_DASHBOARD_GET_GROUP_GROWTH_REBATE":
           // console.log('reducer called   ', action.payload);
            isFetching = false;
            return { ...state, vendorGroupGrowth: action.payload, isFetching }
        case "VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_GRAPH":
                //console.log('reducer called   ', action.payload);
                isFetching = false;
                return { ...state, salesOpportunity: action.payload, isFetching }
        case "VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_BY_BUSINESS":
              //  console.log('reducer called  for business ', action.payload);
                isFetching = false;
                return { ...state, salesOpportunityByBusiness: action.payload, isFetching }
        case "VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_BY_MEMBER":
              //  console.log('reducer called   for member', action.payload);
                isFetching = false;
                return { ...state, getDashboardSalesOpportunityByMember: action.payload, isFetching }
        case "VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_BY_REGION":
               // console.log('reducer called   ', action.payload);
                isFetching = false;
                return { ...state, salesOpportunityByRegion: action.payload, isFetching }
        case "VENDOR_PRODUCT_LIST":
               // console.log('reducer called   ', action.payload);
                isFetching = false;
                return { ...state, getProductListVendorDashboard: action.payload, isFetching }
        case "VENDOR_PRODUCT_CATEGORY":
                 //   console.log('reducer called   ', action.payload);
                    isFetching = false;
                    return { ...state, getProductCategoryVendor: action.payload, isFetching }
        case "VENDOR_CONEVRSION_TAB_ELIGIBILITY_CHECK":
                        //   console.log('reducer called   ', action.payload);
                    isFetching = false;
                    return { ...state, conversionEligibilityCheck: action.payload, isFetching }
        case "VENDOR_MONTHS_FILTER":
                        //   console.log('reducer called   ', action.payload);
                    isFetching = false;
                    return { ...state, getVendorMonthsFilter: action.payload, isFetching }
        case "VENDOR_CONVERSION_MONTHS_FILTER":
                        //   console.log('reducer called   ', action.payload);
                    isFetching = false;
                    return { ...state, getVendorConverisonMonthsFilter: action.payload, isFetching }
        case "VENDOR_DASHBOARD_GET_INDIVIDUAL_GROWTH_REBATE":
                        //   console.log('reducer called   ', action.payload);
                    isFetching = false;
                    return { ...state, getDashboardIndividualGrowthRebate: action.payload, isFetching }
                    
        case "VENDOR_DASHBOARD_GET_MEMBER_PURCHASES_GRAPH":
                        //   console.log('reducer called   ', action.payload);
                    isFetching = false;
                    return { ...state, getMemberPurchasesDataa: action.payload, isFetching }

     case "VENDOR_DASHBOARD_GET_MEMBER_LIST":
                        //   console.log('reducer called   ', action.payload);
                    isFetching = false;
                    return { ...state, getMemberList: action.payload, isFetching }

     case "VENDOR_GET_DATE":
        isFetching = false;
        return { ...state, getMemberVendorDate: action.payload, isFetching }



        default:
            return state;
    }
}